module.exports = "dist/logo_tx.png?7eb26ca2b64f9e0eb69e40441e9cbe0f";